import { ReferenceList } from "../../../../components/referenceList";
import { activeValue } from "../../../../components/collectionTools";
import {
  deleteBatchCatalogs,
  toggleCatalogStatus,
} from "../../../../api/catalogs";
import { setCatalogSearch } from "../../../../reducers/userConfigSlice";
const dateText = (value) =>
  value && Number.isFinite(Date.parse(value))
    ? new Intl.DateTimeFormat("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }).format(new Date(value))
    : "—";
const definition = {
  key: "catalog",
  idKey: "catalogId",
  singular: "catálogo",
  plural: "catálogos",
  nameLabel: "Catálogo",
  searchKey: "catalogSearch",
  setSearch: setCatalogSearch,
  filterId: "catalog-status",
  filterLabel: "Estado",
  filterOptions: () => [
    { value: "active", label: "Activos" },
    { value: "inactive", label: "Inactivos" },
  ],
  matchesFilter: (row, value) =>
    activeValue(row.isActive) === (value === "active"),
  selectAllLabel: "Seleccionar todos los catálogos de esta página",
  searchText: (row) => `${row.name || ""} ${row.reference || ""}`,
  exportName: "catalogos",
  remove: deleteBatchCatalogs,
  toggle: toggleCatalogStatus,
  columns: [
    {
      key: "reference",
      label: "Referencia",
      render: (row) => (
        <span title={row.reference || "Sin referencia disponible"}>
          {row.reference || "—"}
        </span>
      ),
    },
    {
      key: "Products",
      label: "Productos",
      className: "catalogProductCount",
      sortValue: (row) => row.Products?.length ?? -1,
      render: (row) =>
        Array.isArray(row.Products) ? row.Products.length : "—",
    },
    {
      key: "updatedAt",
      label: "Última edición",
      sortValue: (row) => Date.parse(row.updatedAt) || 0,
      render: (row) => (
        <time
          dateTime={
            Number.isFinite(Date.parse(row.updatedAt))
              ? row.updatedAt
              : undefined
          }
        >
          {dateText(row.updatedAt)}
        </time>
      ),
    },
    {
      key: "isActive",
      label: "Estado",
      render: (row) => (
        <span
          className={`catalogStatus ${activeValue(row.isActive) ? "active" : "inactive"}`}
        >
          {activeValue(row.isActive) ? "Activo" : "Inactivo"}
        </span>
      ),
    },
  ],
  exportColumns: [
    { label: "Catálogo", value: (row) => row.name },
    { label: "Referencia", value: (row) => row.reference || "" },
    { label: "Productos", value: (row) => row.Products?.length ?? "" },
    { label: "Última edición", value: (row) => row.updatedAt || "" },
    {
      label: "Estado",
      value: (row) => (activeValue(row.isActive) ? "Activo" : "Inactivo"),
    },
  ],
};
export const CatalogList = (props) => (
  <ReferenceList {...props} definition={definition} />
);
